export default __webpack_public_path__ + "static/media/ad.89237f0d.mp4";